
<div *ngIf="(list && list.length === 0) || (list === undefined)" class="zero-ui" [ngClass]="{'zero-ui-small':'small'==size}">
  <!-- <i nz-icon [nzType]="icon" theme="outline"></i>
  <h2>{{title}}</h2>
  <p>{{message}}</p> -->
  <nz-empty nzNotFoundImage="simple"></nz-empty>
</div>
